module.exports = __webpack_public_path__ + "fonts/Canaro-Medium.3952e8a1.woff";